<template>
	<div>
		<section-entity
			v-for="(insured, i) in insuredListSection"
			:key="i"
			:componentProps="insured.componentProps"
			:componentHandlers="insured.componentHandlers"
			:sectionTitle="sectionTitle"
			v-on="insured.sectionHandlers"
			:showButtons="showButtons"
			:removable="true"
			class="bg5"
		/>
	</div>
</template>

<script>
import SectionEntity from "../SectionEntity"

export default {
	name: "SectionInsured",
	components: {
		SectionEntity
	},
	props: {
		insuredListSection: {
			type: Array
		},
		showButtons: {
			required: false,
			default: true
		}
	},

	data() {
		return {
			sectionTitle: this.$t("insured")
		}
	},

	methods: {}
}
</script>
